import { BaseEntity } from 'yt-ng-framework';

export class Osoba extends BaseEntity {
  constructor(){
      super();
  }
  Ime: string=null;
  Prezime: string=null;
  Jmbg:string=null;
  ImeOca:string=null;
  Devojacko:string=null;
  PolID:number=null;
//   DatumRodj:Date=null;
//   MestoRodjID:number=null;
//   BracniStatusID:number=null;
//   BrojLk:string=null;
//   LboBroj:string=null;
//   NacijaID:number=null;
//   VeroispovestID:number=null;
//   VerskiPraznikID:number=null;
//   StambenoPitanjeReseno:boolean=null;
//   BrojClanovaPorodice:number=null;
//   IzdrzavaClanovaPorodice:number=null;
//   RegulisanaVojnaObaveza:boolean=null;
//   SamohraniRoditelj:boolean=null;
//   Napomena:string=null;
//   FirmaID:number=null;

  Deserialize(input: any){
      // super.Deserialize(input);
      this.ID = input.ID;
      this.Ime = input.Ime;
      this.Prezime = input.Prezime;
      this.Jmbg=input.Jmbg;
      this.ImeOca=input.ImeOca;
      this.Devojacko=input.Devojacko;
      this.PolID=input.PolID;
    //   this.DatumRodj=input.DatumRodj;
    //   this.MestoRodjID=input.MestoRodjID;
    //   this.BracniStatusID=input.BracniStatusID;
    //   this.BrojLk=input.BrojLk;
    //   this.LboBroj=input.LboBroj;
    //   this.NacijaID=input.NacijaID;
    //   this.VeroispovestID=input.VeroispovestID;
    //   this.VerskiPraznikID=input.VerskiPraznikID;
    //   this.StambenoPitanjeReseno=input.StambenoPitanjeReseno;
    //   this.BrojClanovaPorodice=input.BrojClanovaPorodice;
    //   this.IzdrzavaClanovaPorodice=input.IzdrzavaClanovaPorodice;
    //   this.RegulisanaVojnaObaveza=input.RegulisanaVojnaObaveza;
    //   this.SamohraniRoditelj=input.SamohraniRoditelj;
    //   this.Napomena=input.Napomena;
    //   this.FirmaID=input.FirmaID;
    
      return this;
  }

  Serialize(input: Osoba){
      return input;
  }
}
